module.exports = __webpack_public_path__ + "media/images/athletes/3550-394c9d19ad27f61e8e54405e4bdbb867.png";